import React, { useState, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, IconButton, Icon, Row, Table, Message, Col, Toggle, Whisper, Popover } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { saveProjectTemplate } from '../../redux/actions/projectTemplate'
import { doneLoading, startLoading } from '../../utils/loading'
import pathname from '../../constants/pathname'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import TooltipButton from '../../components/buttons/TooltipButton'
import InputForm from '../../components/forms/input/InputForm'
import { Controller, useForm } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import InputDateForm from '../../components/forms/input/InputDateForm'
import EditButton from '../../components/buttons/editButton/EditButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import {
  createManageProposalForm,
  createNewVersionManageProposalForm,
  delManageProposalForm,
  saveManageProposalForm,
} from '../../redux/actions/subProjectFormSetting'
import {
  ADD,
  ADD_EDIT,
  CANCEL,
  DEFAULT_ERR_MSG,
  DELETE_SUCCESS_MSG,
  SAVE,
  SAVE_SUCCESS_MSG,
} from '../../constants/msgText'
import { sessionSetItemStr } from '../../utils/sessionHelpers'
import notification from '../../utils/notification'
import moment from 'moment'
import { DD_MM_YYYY_SLASH, REQUEST_DATE_FORMAT } from '../../constants/date'
import { TEMP_FORM_ID } from '../../constants/constants'

export default function ManageProposalFormWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  // const { schema, buttonText } = props
  const [schema, setSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState()
  const [isAdd, setIsAdd] = useState()
  const [isEdit, setIsEdit] = useState()
  const [addRequest, setAddRequest] = useState()
  const [isConfirmSave, setIsConfirmSave] = useState()
  const [isConfirmEdit, setIsConfirmEdit] = useState()
  const [isConfirmDelete, setIsConfirmDelete] = useState()
  const [selectedId, setSelectedId] = useState()
  const [selectedEditObj, setSelectedEditObj] = useState()

  const dispatch = useDispatch()
  let history = useHistory()

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [containerRef, windowWidth])

  const handleSave = async (request) => {
    console.log('handleSave : ', request)

    setIsLoading(true)
    startLoading()
    try {
      const response = await saveManageProposalForm(selectedEditObj.id, request)

      if (response?.projectTemplete) {
        setSchema(response.projectTemplete)
        setAddRequest('')
        setIsEdit(false)
        setSelectedEditObj('')

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDelete = async () => {
    setIsLoading(true)
    startLoading()
    setIsConfirmDelete(false)
    try {
      const response = await delManageProposalForm(selectedId)
      console.log('res : ', response)

      if (response?.projectTemplete) {
        setSchema(response.projectTemplete)
        setSelectedId('')

        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
          duration: 2500,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleCreate = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await createManageProposalForm(request)

      if (response?.successed) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })

        sessionSetItemStr(TEMP_FORM_ID, response.id)

        doneLoading()
        setIsLoading(false)

        history.push({
          pathname: pathname.subProjectNew.settingProposal.projectName,
        })
      } else {
        notification.open('error', {
          title: response.message || DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleUpVersion = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await createNewVersionManageProposalForm(id)

      if (response?.successed) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })

        doneLoading()
        setIsLoading(false)

        onEdit(response.id)
      } else {
        notification.open('error', {
          title: response.message || DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onAdd = () => {
    setIsAdd(true)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      id: selectedEditObj?.id || '',
      templateName: data.templateName,
      refTemplate: data.refTemplate,
      startDate: moment(data.startDate).format(REQUEST_DATE_FORMAT) || null,
      endDate: moment(data.endDate).format(REQUEST_DATE_FORMAT) || null,
      active: data.active,
    }

    if (isEdit) {
      handleSave(request)
    } else {
      setAddRequest(request)
      setIsConfirmSave(true)
    }
  }

  const onEdit = (id) => {
    sessionSetItemStr(TEMP_FORM_ID, id)

    history.push({
      pathname: pathname.subProjectNew.settingProposal.templeteDetail,
    })
  }

  return (
    <>
      <div ref={containerRef}>
        <Panel
          // key={item.id}
          header={schema.header}
          bordered
          collapsible
          defaultExpanded
          shaded
          style={{ marginBottom: 20 }}
        >
          {isAdd || isEdit ? (
            <>
              <Row>
                <Col>
                  <InputForm
                    schema={schema.inputForm.templateName}
                    value={isEdit ? selectedEditObj?.name : schema.inputForm.templateName.value}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                {isAdd && (
                  <Col>
                    <InputSelectForm
                      schema={schema.inputForm.refTemplate}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                )}

                <Col lg={12} md={12} sm={24} xs={24}>
                  <InputDateForm
                    schema={schema.inputForm.startDate}
                    value={
                      isEdit
                        ? moment(selectedEditObj.startDate, DD_MM_YYYY_SLASH)
                            .add(-543, 'y')
                            .toDate()
                        : schema.inputForm.startDate.value
                    }
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <InputDateForm
                    schema={schema.inputForm.endDate}
                    value={
                      isEdit
                        ? moment(selectedEditObj.endDate, DD_MM_YYYY_SLASH).add(-543, 'y').toDate()
                        : schema.inputForm.endDate.value
                    }
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
              </Row>

              {isEdit && schema?.inputForm?.active && (
                <Row>
                  <Col>
                    <Controller
                      key={schema.inputForm.active.name}
                      name={schema.inputForm.active.name}
                      control={control}
                      rules={isValidators(schema.inputForm.active.validators)}
                      defaultValue={selectedEditObj?.status == 1}
                      //value={inputValue}
                      render={(props) => {
                        return (
                          <div style={{ marginTop: 10 }}>
                            <p>
                              {requiredFiled(
                                schema.inputForm.active.validators,
                                `${schema.inputForm.active.label}`
                              )}
                            </p>
                            <Toggle
                              defaultChecked={
                                isEdit
                                  ? selectedEditObj.status == 1
                                  : schema.inputForm.active.value == '1'
                              }
                              size="lg"
                              checkedChildren={'Active'}
                              unCheckedChildren="Inactive"
                              onChange={(value) => {
                                // console.log(value)
                                props.onChange(value)
                              }}
                            />
                          </div>
                        )
                      }}
                    />
                  </Col>
                </Row>
              )}

              <hr />
              <div className="right">
                <SaveButton disabled={isLoading} children={SAVE} onClick={handleSubmit(onSubmit)} />
                <CancelButton
                  children={CANCEL}
                  onClick={() => {
                    setIsAdd(false)
                    setIsEdit(false)
                    setSelectedEditObj({})
                  }}
                />
              </div>
            </>
          ) : (
            <TooltipButton
              isStart={true}
              icon="plus"
              tooltip={`${ADD}`}
              style={{
                marginLeft: 10,
              }}
              children={`${ADD}`}
              onClick={onAdd}
            />
          )}

          <Table wordWrap autoHeight data={schema.value} style={{ marginTop: 40 }}>
            <Column width={90} align="center">
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column minWidth={350} width={500} flexGrow={1}>
              <HeaderCell>
                <p>ชื่อประเด็น</p>
              </HeaderCell>
              <Cell dataKey="name" />
            </Column>
            <Column width={150}>
              <HeaderCell>
                <p>สำนัก</p>
              </HeaderCell>
              <Cell dataKey="department" />
            </Column>
            <Column width={250} align="center">
              <HeaderCell>
                <p>ช่วงเวลาที่เปิดรับ</p>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      {rowData.startDate || ''} - {rowData.endDate || ''}
                    </>
                  )
                }}
              </Cell>
            </Column>
            <Column width={120} align="center">
              <HeaderCell>
                <p>สถานะ</p>
              </HeaderCell>
              <Cell dataKey="statusName" />
            </Column>
            <Column width={100} align="center">
              <HeaderCell>
                <p>เวอร์ชัน</p>
              </HeaderCell>
              <Cell dataKey="version" />
            </Column>
            <Column
              width={100}
              align="center"
              // verticalAlign="middle"
            >
              <HeaderCell>จัดการ</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      <Whisper
                        trigger="click"
                        placement={'bottom'}
                        speaker={
                          <Popover title="" style={{ minWidth: 150, maxWidth: 250 }}>
                            <EditButton
                              style={{
                                marginTop: 5,
                                marginBottom: 5,
                                width: '100%',
                              }}
                              children="แก้ไขประเด็น"
                              onClick={() => {
                                setIsAdd(false)
                                setIsEdit(true)
                                setSelectedEditObj(rowData)
                              }}
                            />
                            <ViewButton
                              style={{
                                marginTop: 5,
                                marginBottom: 5,
                                width: '100%',
                              }}
                              children="แสดงแบบฟอร์ม"
                              onClick={() => onEdit(rowData.id)}
                            />

                            {rowData.status == 1 && (
                              <EditButton
                                style={{
                                  marginTop: 5,
                                  marginBottom: 5,
                                  width: '100%',
                                }}
                                icon="pencil"
                                onClick={() => {
                                  if (rowData.actived) {
                                    setSelectedId(rowData.id)
                                    setIsConfirmEdit(true)
                                  } else {
                                    onEdit(rowData.id)
                                  }
                                }}
                                children="แก้ไขแบบฟอร์มประเด็น"
                              />
                            )}

                            <CancelButton
                              isStart={true}
                              icon="trash-o"
                              style={{
                                marginTop: 5,
                                marginBottom: 5,
                                width: '100%',
                              }}
                              buttonClass="rs-btn-ghost-cancel"
                              iconClass={'bt-gost-icon-radius-all-cancel'}
                              children={`ลบประเด็น`}
                              onClick={() => {
                                setSelectedId(rowData.id)
                                setIsConfirmDelete(true)
                              }}
                            />
                          </Popover>
                        }
                      >
                        <TooltipButton
                          isStart={true}
                          icon="ellipsis-h"
                          tooltip={`จัดการ`}
                          buttonClass="rs-btn-ghost-edit"
                          iconClass="bt-gost-icon-radius-edit"
                          style={{
                            marginTop: 5,
                          }}
                        />
                      </Whisper>
                      {/* <TooltipButton
                        isStart={true}
                        icon="edit"
                        tooltip={`แก้ไข`}
                        style={
                          {
                            // marginLeft: 10,
                          }
                        }
                        children={'แก้ไข'}
                        buttonClass="rs-btn-ghost-edit"
                        iconClass={'bt-gost-icon-radius-all-edit'}
                        onClick={() => onEdit(rowData.id)}
                      /> */}
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </Panel>

        <ConfirmWidget
          title={'ยืนยัน'}
          show={isConfirmDelete}
          detail={`ยืนยันการลบประเด็น`}
          onCancle={() => {
            setIsConfirmDelete(false)
          }}
          onConfirm={handleDelete}
        />

        <ConfirmWidget
          title={'ยืนยัน'}
          show={isConfirmSave}
          detail={`ยืนยันการบันทึกสร้างประเด็น`}
          onCancle={() => {
            setIsConfirmSave(false)
          }}
          onConfirm={() => {
            setIsConfirmSave(false)
            handleCreate(addRequest)
          }}
        />

        <ConfirmWidget
          title={'ยืนยัน'}
          show={isConfirmEdit}
          size="sm"
          detail={
            <>
              <p>ยืนยันแก้ไขแบบฟอร์มประเด็น</p>
              <p style={{ marginTop: 10, color: '#fb8a81' }}>
                <i>
                  *** เนื่องจากประเด็นนี้เคย Active ไปแล้ว
                  การแก้ไขแบบฟอร์มประเด็นจะเป็นการสร้างเวอร์ชันใหม่ ***
                </i>
              </p>
            </>
          }
          onCancle={() => {
            setIsConfirmEdit(false)
            // setAddRequest('')
          }}
          onConfirm={() => {
            handleUpVersion(selectedId)
            setIsConfirmEdit(false)
          }}
        />
      </div>
    </>
  )
}
